import { Controller } from "@hotwired/stimulus"
import { bottomBarTop, isDesktop } from "../lib/helpers"

const CUSTOM = "[data-rich-dropdown-custom]"

export default class extends Controller {
  static values = { optionAttribute: String }

  // popup:render. Below the desktop breakpoint the open list ends above the phone bottom bar.
  constrain({ detail: { open } }) {
    const options = this.element.querySelector(".rich-dropdown-options")
    options.style.maxHeight = ""
    if (!open || isDesktop()) return

    const bottom = bottomBarTop() ?? window.innerHeight
    const available = Math.floor(bottom - options.getBoundingClientRect().top - 8)
    options.style.maxHeight = `${Math.max(8, available)}px`
  }

  // A pick. The owner listens for rich-dropdown:change, decides what it means, and answers with rich-dropdown:show.
  select({ currentTarget }) {
    this.dispatch("change", {
      detail: {
        key: currentTarget.getAttribute(this.optionAttributeValue) || "",
        custom: currentTarget.matches(CUSTOM),
      },
    })
  }

  // rich-dropdown:show from the owner. The option with this key becomes the current one: hidden
  // from the list and copied to the trigger. A key no option has is Custom: its row when the list
  // has one, and the root's custom copy.
  show({ detail: { key } }) {
    const options = [...this.element.querySelectorAll(`[${this.optionAttributeValue}], ${CUSTOM}`)]
    const keyed = options.find((option) => option.getAttribute(this.optionAttributeValue) === key)
    const current = keyed || options.find((option) => option.matches(CUSTOM))

    for (const option of options) {
      option.hidden = option === current
      option.setAttribute("aria-selected", String(option === current))
    }

    const { customLabel, customBlurb } = this.element.dataset
    const label = keyed ? keyed.dataset.richDropdownOptionLabel : customLabel
    if (label == null) return

    this.element.querySelector("[data-rich-dropdown-trigger-label]").textContent = label
    this.element.querySelector("[data-rich-dropdown-trigger-blurb]").textContent =
      keyed ? keyed.dataset.richDropdownOptionBlurb : customBlurb

    // The accessible name is "prefix: visible label" (WCAG 2.5.3 Label in Name).
    const trigger = this.element.querySelector("[data-popup-target='button']")
    trigger.setAttribute("aria-label", `${trigger.dataset.richDropdownNamePrefix}: ${label}`)
  }
}
